import React from 'react';
import PropTypes from 'prop-types';
import MyAccountCardField from './MyAccountCardField';

import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import MyAccountAPIService from '@lib/api-services/MyAccountAPIService';
import Button from '../common/Button';

export default class MyAccountCard extends React.Component {
    static propTypes = {
        model: PropTypes.object
    }

    title = ''
    endpoint = ''

    constructor(props) {
        super(props)

        scheduleAtDocumentReady(() => {
            this.myAccountAPIService = APIServicesRegistry.getService(MyAccountAPIService)
        })
    }

    onSaveChangesButtonClick = e => {
        this.myAccountAPIService.post(this.endpoint, this.getModel()).then(response => {
            if (response.status == 200) {
                window.setTimeout(() => {
                    window.location = window.location
                }, 5000);
            }

        })


    }

    render() {
        return (
            <div className="card">
                <div className="card-title p-b-0">{this.title}</div>
                <div className="card-body p-b-0">
                    {this.renderBody()}
                </div>
                <div className="card-footer clearfix p-t-0">
                    {this.renderSaveButton()}
                    {this.renderButtons()}


                </div>
            </div>
        )
    }

    renderSaveButton() {
        return (
            <div className="align-right">
                <Button size={Button.Size.Small} color={Button.Color.Gray} onClick={this.onSaveChangesButtonClick}>
                    {__('Save changes')}
                </Button>
            </div>
        );

    }

    renderBody() {
        return <React.Fragment></React.Fragment>;
    }

    renderButtons() {
        return <React.Fragment></React.Fragment>
    }

    /**
     * Renders an editable field.
     *
     * @private
     * @param {String} name
     * @param {String} type
     * @param {*} value
     * @param {Function} onChange
     */
    renderInputField(name, type, value, onChange) {
        return (
            <MyAccountCardField label={name}>
                <input type={type} value={value} onChange={e => onChange(e.target.value)}/>
            </MyAccountCardField>
        )
    }

    renderTextField(name, value, onChange) {
        return this.renderInputField(name, 'text', value, onChange)
    }

    renderCheckboxField(name, value, onChange) {
        return (
            <MyAccountCardField label={name}>
                <input id={name} type="checkbox" checked={value} onChange={e => onChange(e.target.checked)}/>
                <label htmlFor={name}/>
            </MyAccountCardField>
        )
    }

    renderPasswordField(name, value, onChange) {
        return this.renderInputField(name, 'password', value, onChange)
    }

    renderSelectField(name, value, items, onChange) {
        if (!items)
            return <React.Fragment/>

        return (
            <MyAccountCardField label={name}>
                <select value={value} onChange={e => onChange(e.target.value)}>
                    {items.map(o => (
                        <option key={o.value} value={o.value}>{o.text}</option>
                    ))}
                </select>
            </MyAccountCardField>
        )
    }

    renderEnumFlagsField(name, value, items, onChange) {
        return (
            <MyAccountCardField label={name}>
                <EnumFlagsField field={{items, value, onChange}}/>
            </MyAccountCardField>
        )
    }

    /**
     * Returns a model to be sent to the server upon clicking save.
     *
     * @abstract
     * @return {Object}
     */
    getModel() {
        return {}
    }
}

class EnumFlagsField extends React.Component {
    render() {
        return (
            <ul>
                {this.props.field.items.map(x => this.renderItem(x))}
            </ul>
        )
    }

    renderItem = x => (
        <li key={x.value}>
            <input id={x.value} checked={this.isSelected(x)} onChange={e => this.onChange(x, e.target.checked)}
                   type="checkbox"/>
            <label htmlFor={x.value}>{x.text}</label>
        </li>
    )

    isSelected = x => {
        return (x.value & this.props.field.value) !== 0
    }

    onChange = (x, checked) => {
        const value = checked ? this.props.field.value | x.value : this.props.field.value ^ x.value;
        this.props.field.onChange(value);
    }
}